// Renders project tag chips for a task row using display-name lookup.
import TagChip from '@/components/ui/TagChip';
import { abbreviateProjectDisplayName } from '@/features/tasks/utils/ui/projectPillAbbreviation';

/**
 * @param {{
 *   allProjects: string[],
 *   projectDisplayMap: Map<string, string>,
 *   projectColorMap?: Map<string, number>,
 *   dense?: boolean,
 *   displayTier?: 'full' | 'abbrev' | 'dot',
 * }} props
 */
const TaskProjectPills = ({
  allProjects,
  projectDisplayMap,
  projectColorMap,
  dense = false,
  displayTier = 'full',
}) => {
  if (!allProjects || allProjects.length === 0) return null;

  return (
    <>
      {allProjects.map((p) => {
        const name =
          projectDisplayMap.get(p) ||
          projectDisplayMap.get(p.toLowerCase()) ||
          p;
        const projectId = String(p).trim().toLowerCase();
        const colorIndex =
          projectColorMap?.get(projectId) ??
          projectColorMap?.get(p) ??
          undefined;
        const visibleLabel =
          displayTier === 'abbrev'
            ? abbreviateProjectDisplayName(name)
            : displayTier === 'dot'
              ? ''
              : name;
        return (
          <TagChip
            key={p}
            tag={p}
            label={visibleLabel}
            aria-label={name}
            projectColorIndex={colorIndex}
            dense={dense}
            listRowProjectPill
            projectDisplayTier={displayTier}
            data-testid="task-item__project-chip"
            data-project-pill-tier={displayTier}
          />
        );
      })}
    </>
  );
};

export default TaskProjectPills;
